/*
 * File: ProviderOfficeFeeFab.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 09/12/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the edit provider, office FAB
 */
import React from "react";
import UIStore from "services/patients/store/UIStore";
import { observer } from "mobx-react";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import EditProviderOfficeFee from "./EditProviderOfficeFee";
import UIFormDialog from "components/ui/UIFormDialog";
import UIFab from "components/ui/UIFab";
import PropTypes from "prop-types";

class ProviderOfficeFeeFab extends React.Component {
  constructor(props) {
    super(props);
    this.store = {
      providerOfficeFeeUIStore: UIStore.create()
    };
  }

  editProviderOfficeFeeSchedule = () => {
    return (
      <EditProviderOfficeFee
        parentCallBack={this.formCallBack}
        patient={this.props.patient}
        providerOfficeFeeModel={this.props.providerOfficeFeeModel}
      />
    );
  };

  formCallBack = copyModel => {
    this.store.providerOfficeFeeUIStore.toggleFormDialog();
    this.props.editCallBack(copyModel);
  };

  render() {
    let UIStore = this.store.providerOfficeFeeUIStore;
    let showEditForm = UIStore.showFormDialog;
    let title = "Edit Provider, Office, Fee Schedule";
    return (
      <div>
        <UIFab
          icon={<FavoriteBorderIcon />}
          handleClick={this.store.providerOfficeFeeUIStore.toggleFormDialog}
          name={"Edit Provider, Office, & Fee Schedule"}
        />

        <UIFormDialog
          open={showEditForm}
          toggleDialog={UIStore.toggleFormDialog}
          title={title}
          viewPage={this.editProviderOfficeFeeSchedule}
        />
      </div>
    );
  }
}

ProviderOfficeFeeFab.propTypes = {
  patient: PropTypes.object.isRequired,
  providerOfficeFeeModel: PropTypes.object.isRequired,
  editCallBack: PropTypes.func.isRequired
};

export default observer(ProviderOfficeFeeFab);
